import * as yup from 'yup';
import { t } from 'i18next';
import dayjs from '@/plugin/dayjs';

export const surveySchema = () => {
    return yup.object().shape({
        email: yup.string().email().required(t('survey.form.email.required')),
        phone_number: yup
            .string()
            .required(t('survey.form.phoneNumber.required'))
            .matches(/([\\+84|84|0]+(\d{1,3}))+([0-9]{8})\b/, t('survey.form.phoneNumber.invalid')),
        date_of_birth: yup
            .string()
            .required(t('survey.form.dateOfBirth.required'))
            .test('date_of_birth', t('survey.form.dateOfBirth.invalid'), (value) => {
                if (!value) return false;
                if (dayjs(value, 'DD/MM/YYYY').isValid()) {
                    if (dayjs(value, 'DD/MM/YYYY').isAfter(dayjs().subtract(1, 'day'))) {
                        return false;
                    }
                    return true;
                }
                return false
            }),
        age_group: yup.string().required(t('survey.form.ageGroup.required')),
        bio: yup.string().max(500, t('survey.form.bio.max')),
        native_language: yup.string().required(t('survey.form.nativeLanguage.required')),
        target_language: yup.string().required(t('survey.form.targetLanguage.required')),
        current_level: yup.string().required(t('survey.form.currentLevel.required')),
        target_level: yup.string().required(t('survey.form.targetLevel.required')),
        english_experience: yup.string().required(t('survey.form.englishExperience.required')),
        daily_commitment: yup.string().required(t('survey.form.dailyCommitment.required')),
        learning_goal: yup.string().required(t('survey.form.learningGoal.required')),
        learning_style: yup.string().required(t('survey.form.learningStyle.required')),
        study_reminders: yup.boolean(),
        achievement_notifications: yup.boolean(),
    });
};
